export enum WidgetKey {
  TIME_TRACKING = 'time-tracking',
  TASK_MANAGEMENT = 'task-management',
  CLOCK = 'clock',
  GOAL_WIDGET = 'goal-widget',
  BUDGET = 'budget',
  CALENDAR = 'calendar',
  TIPS = 'tips',
  TODOS = 'todos',
  CSM_PERFORMANCE_OVERVIEW = 'csm-performance-overview',
  AI_ARTIFACT_TILE = 'ai-artifact-tile'
}

export enum WidgetSize {
  SMALL = 'S',
  MEDIUM = 'M',
  LARGE = 'L'
}

// kept separate from WIDGETS_CONFIG so grid code can look up a widget's
// display name without pulling in its React component tree, which would
// create a circular import.
export const WIDGET_NAMES: Record<WidgetKey, string> = {
  [WidgetKey.TIME_TRACKING]: 'Time Tracking',
  [WidgetKey.CLOCK]: 'Clock',
  [WidgetKey.GOAL_WIDGET]: 'Sales',
  [WidgetKey.BUDGET]: 'Bonus',
  [WidgetKey.TASK_MANAGEMENT]: 'Task Management',
  [WidgetKey.CALENDAR]: 'Calendar',
  [WidgetKey.TIPS]: 'Tips',
  [WidgetKey.TODOS]: 'Todos',
  [WidgetKey.CSM_PERFORMANCE_OVERVIEW]: 'CSM Performance Overview',
  [WidgetKey.AI_ARTIFACT_TILE]: 'AI Artifact'
}
